const Url = {
  /**
   * 登录
   * */
  login: '/smartShop/spread/user/code/login',
  // 发送短信
  sendSms: '/smartShop/sms/sendSMS',
  sendSelfSms: '/wx/func/mer/sendSms',
  // 上传文件
  uploadFile: '/api/common/fileUpload',
  // 上传文件
  uploadFile2: '/api/common/getFileUrl',
  // 生成打赏订单
  createRewardOrder: '/order/app/addTipOrder',
  // 获取投票活动
  findVoteInfo: '/voting/app/findRelaeaseVoting',
  // 获取投票选手
  getVotePlayers: '/voting/app/getVotObject',
  // 投票
  doVote: '/voting/app/votingAdd',
  // 获取投票活动选手的图片
  getPlayerPics: '/voting/app/getVotObjectPic',
  // =========================================
  // 获取投票活动名称
  findPersonVoteByAreaCode: '/voting/person/app/findVotingByVoteregion',
  // 获取投票活动
  findPersonVoteInfo: '/voting/person/app/findRelaeaseVoting',
  // 获取投票选手
  getPersonVotePlayers: '/voting/person/app/getVotObject',
  // 投票
  doPersonVote: '/voting/person/app/votingAdd',
  // 获取投票活动选手的图片
  getPersonPlayerPics: '/voting/person/app/getVotObjectPic',
  // 获取报名须知
  findVotingPlacard: '/voting/person/app/findVotingPlacard',
  // =============================================
  /**
   * 酒庄
   * */
  winery: {
    // 轮播图
    getPiccarouselByShopId: '/wx/func/getPublicPicCarousel',
    // 商品类别
    getShopGoodType: '/wx/goods/getShopGoodType',
    // 推荐商品
    getRecommondGoods: '/wx/goods/getShopRecommondGoodForYou',
    // 优惠信息
    getPreferentialInfo: '/wx/payment/getCouponListByShopId',
    // 获取商品类型下的商品列表
    getShopGoodsByGoodType: '/wx/goods/getShopGoodsByGoodType',
    // 商品详情
    getGood: '/wx/goods/getGoodsByGoodId',
    // 提交订单
    submitOrder: '/order/addPlatformOrderInfo',
    // 商品评价
    goodEvcaluate: '/wx/bar/addUserEvaluate'
  },
  /**
   * *****************************
   * 酒吧接口
   * *****************************
   */
  bar: {
    // 酒吧公共轮播图
    barPicCarousel: '/wx/func/getPublicPicCarousel',
    // 最近一次去的酒吧
    userLastTimeBar: '/wx/bar/getLastBar',
    // 离用户最近的酒吧
    userNearestBar: '/wx/bar/getNearestDistanceBar',
    // 所有酒吧
    allBar: '/wx/bar/getAllShopWithDistance',
    // 酒吧详情
    barInfo: '/wx/bar/getShopByShopId',
    // 酒吧轮播图
    getPiccarouselByShopId: '/wx/bar/getPiccarouselByShopId',
    // 优惠信息
    getPreferentialInfo: '/wx/payment/getCouponListByShopId',
    // 预约酒吧
    appointmentBar: '/advance/app/addAdvance',
    // 商品分类
    getShopGoodType: '/wx/goods/getAllShopGoodsWithGoodType',
    // 提交订单
    submitOrder: '/order/addShopOrder',
    // 获取范围内的酒吧
    getRangeBars: '/wx/bar/getShopWithSpot',
    // 酒吧评价列表
    getBarEvaluates: 'wx/bar/getShopUserEvaluate',
    // 夜图推荐
    getAllShopRecommond: '/wx/bar/getAllShopRecommond',
    // 我的足迹
    myFootprint: '/wx/bar/findMerBeenToShop',
    // 酒吧服务员列表
    waiterList: '/wx/user/getWaiterByShopId',
    // 呼叫服务员
    callWaiter: '/wx/func/app/CallAttendant',
    // 酒吧评价
    evaluate: '/wx/bar/addUserShopEvaluate',
    // 酒吧桌子类型
    barDeskType: '/wx/bar/getShopDeskType',
    // 酒吧桌子列表
    barDeskList: '/wx/bar/getShopBarDeskList',
    // 取消预约
    cancelReservation: '/advance/app/delAdvanceById',
    // 是否可与预约
    isAppointment: '/wx/bar/getShopCanAppointment',
    // 获取投票活动名称
    findVoteByAreaCode: '/voting/app/findVotingByVoteregion',
    // 陌生交友 积分验证
    friendshipIntegralVerify: '/member/judgeInteractiveIntegralRide'
  },
  /**
   * 订单查询
   */
  queryOrder: {
    wineryOrder: '/order/findOrderInfoAppByMerID',
    barOrder: '/order/findOrderInfoAppByMerID',
    appointmentOrder: '/advance/app/findAdvanceByMerID',
    orderDetail: '/order/app/findOrderInfoAppByID',
    // 演艺订单
    showOrders: '/order/showtime/app/findAdvanceOrderByMerID'
  },
  order: {
    // 取消订单
    cancelOrder: '/order/app/cancelOrder',
    // 确认订单
    confirmOrder: '/order/app/buyerGoodsReceipt',
    // 根据订单号查询
    queryGoodsInfoByOrderId: '/order/app/getOrderShopInfoList',
    // 艺人订单-完成订单
    completeOrder: '/order/showtime/app/buyerCompleteOrderInfo'
  },
  my: {
    // 收货地址
    queryAddrs: '/wx/user/getUserRecAddress',
    saveAddr: '/wx/user/addMemRecAddress',
    setDefaultAddr: '/wx/user/upateUserRecAddressIsdefault',
    removeAddr: '/wx/user/delUserRecAddress',
    // 钱包接口
    queryBalance: '/myWallet/findMyWalletByMerID',
    // 充值
    recharge: '/order/addWalletOrderInfo',
    // 充值优惠列表
    couponList: '/wx/payment/getCouponALLListByShopId',
    // 优惠充值
    couponRecharge: '/order/addCouponOrderInfo',
    // 我的团队
    queryMyTeams: '/linkuser/getLinkUserByMerID',
    // 统计3级人员总数
    getTeamLevel: '/linkuser/app/getLeveL',
    // 我的佣金
    queryMyBrokerage: '/myWallet/findSpecWalletDtoByID',
    // 佣金提现
    brokerageCash: '/orderWithdraw/app/brokerageChecksWithdraw',
    // 转存钱包
    transWallet: '/myWallet/walletTransfer',
    // 添加团队成员
    addTeamUser: '/linkuser/addLinkUser',
    // 打赏小费
    reward: '/order/addTipOrder',
    // 钱包明细
    walletDetail: '/myWallet/app/findMyWalletLogByMerIdApp',
    // 修改支付密码
    resetPwd: '/myWallet/app/editWalletPwd',
    // 佣金明细
    brokerageDetail: '/myWallet/app/findMySpecWalletLogByMerID',
    // 佣金收入明细
    brokerageIncomeDetail: '/linkuser/app/getMyFeeSplittingLog'
  },
  waiter: {
    login: '/wx/user/waiterLogin',
    // 预约订单列表
    waitingOrder: '/advance/app/findAdvanceByMerchanID',
    // 服务员余额
    waiterBalance: '/myWallet/app/findTipWalletDtoByID',
    // 小费提现
    withdrawGratuity: '/orderWithdraw/app/tipChecksWithdraw',
    // 小费明细
    gratuityDetail: '/myWallet/app/findTipWalletLogByMerID',
    // 取消预约
    cancelAdvance: '/advance/app/waiterCancelAdvance',
    // 接受预约
    acceptAdvance: '/advance/app/waiterAcceptAdvance',
    // 酒吧桌号列表
    barDeskList: '/wx/bar/getBarDeskList'
  },
  // 信用
  credit: {
    // 信用主页
    home: '/wx/user/findIntegralByMer',
    desc: '/wx/user/findCreditDescription',
    record: '/wx/user/findIntegralLog'
  },
  user: {
    // 添加微信号
    addWxNo: '/wx/user/addWechatnum',
    // 添加身份证照片信息
    addIdCard: '/wx/user/addIdCard',
    // 添加生活照
    addLifePhotos: '/api/wx/user/fileMemberUpload',
    delLifePhotos: '/wx/user/deleteMemberFile',
    findMemberFileByMerId: '/wx/user/findMemberFileByMerId',
    // 上传头像
    addProtrait: '/wx/user/addProtrait',
    // 个人信息
    userInfo: '/wx/user/myInformation',
    // 修改个人信息
    updateUserInfo: '/wx/user/updateMemeberDirections'
  },
  showTime: {
    // 获取可预约时间
    appointmentTimes: '/wx/bar/getBarAppointmentTimeList',
    // 艺人列表
    artistList: '/wx/bar/getArtistList',
    // 艺人详情
    artistInfo: '/wx/bar/getArtistDetail',
    // 提交订单
    submitOrder: '/order/showtime/app/addShowTimeOrderInfo',
    addHot: '/order/showtime/app/votingAdd'
  },
  entertainer: {
    login: '/wx/user/artistLogin',
    // 艺人详情
    userInfo: '/wx/bar/getArtistDetail',
    // 钱包余额
    walletBalance: '/myWallet/app/findShowWalletDtoByID',
    // 钱包明细
    walletHistorys: '/myWallet/app/findShowWalletLogByMerID',
    // 艺人提现
    checksWithdraw: '/orderWithdraw/app/showChecksWithdraw',
    // 待接受的订单列表
    acceptedOrderList: '/order/showtime/app/findAdvanceNewOrderByArtistId',
    // 演艺人员订单列表
    orderList: '/order/showtime/app/findAdvanceOrderByArtistId',
    // 备忘列表
    memoList: '/order/showtime/web/findAdvanceToDayById',
    // 订单详情
    orderDetail: '/order/showtime/app/findAdvanceShowById',
    // 拒绝订单
    refuseOrder: '/order/showtime/app/RefuseAdvance',
    // 接受订单
    acceptOrder: '/order/showtime/app/AcceptAdvance'
  }
}

export default Url



// WEBPACK FOOTER //
// ./src/js/url.js